import * as React from "react";
import type { SVGProps } from "react";
const SvgProducts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#D6DBE7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.01 3.03V21M12 10.22h9M12.01 14.72H3.02"
    />
    <path
      stroke="#D6DBE7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgProducts;
